const backendUrl: string = 'http://localhost:8787';
const autoContentBackendUrl: string = 'http://localhost:8787';

export const environment = {
  signupUrl: backendUrl + '/audience/auth',
  otpVerificationUrl: backendUrl + '/verify/validate/otp',
  dataUpdateUrl: backendUrl + '/audience/update',
  otpSendUrl: backendUrl + '/verify/send/otp',
  mixpanelProjectToken: 'd7f913ac10b9c8df7fab41375dd25ecb',
  verifyStripePayment: backendUrl + '/checkout/verify-stripe-payment',
  stripeCheckoutLink: 'https://buy.stripe.com/test_cN2eYLcIpdpveic000',
  getPhonePeCheckoutLink: backendUrl + '/checkout/get-phonepe-payment-url',
  verifyPhonePePayment: backendUrl + '/checkout/check-phonepe-payment-status',
  referUrl: backendUrl + '/refer',
  autoContentUrl: autoContentBackendUrl + '/',
  verifyGoogleTokenUrl: backendUrl + '/verify-google-token',
  googleSignupClientId:
    '1004152744305-kl3sef173a795f81nd1de60bpc6lj2je.apps.googleusercontent.com',
  payUCheckoutLink: backendUrl + '/checkout/get-payu-payment-url',
  verifyPayUPayment: backendUrl + '/checkout/check-payu-payment-status',
  GTMContainerId: 'GTM-TESTING',
};
